import { createContext, FC, ReactElement, useState } from "react";
import { ToasterContextType } from "../../types/ciptex-sdk";
import { useToaster, Toaster } from "@twilio-paste/toast";

export interface ReactElementProps {
	children: ReactElement;
}

export const ToasterContext = createContext<ToasterContextType>(null!);

export const ToasterProvider: FC<ReactElementProps> = ({ children }: ReactElementProps) => {
	const toaster = useToaster();
	const [ providerReady ] = useState<boolean>(true);

	return (
		<ToasterContext.Provider value={{ providerReady, toaster }}>
			<Toaster {...toaster} />
			{children}
		</ToasterContext.Provider>
	);
};